import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { VitalsFormField } from './formField'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { AdapterOptions, SectionAdapter } from '../../../adapters/types'
import { getAnswerValuesFromItems } from '../../../helpers'
import { RocFormData } from '../../types/RocFormData'
import { FlatAnswerMutation } from '../../../adapters/types'

/**
 * Vitals subsection adapter
 */
export class VitalsAdapter extends SectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const flatAnswersArray = Object.values(flatAnswers)

    const temperature = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_TEMPERATURE
    )?.at(0)

    const pulse =
      getAnswerValuesFromItems(flatAnswersArray, RocAssessmentQuestionnaireItem.VITALS_PULSE)?.at(
        0
      ) || undefined

    const respirations = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_RESPIRATIONS
    )?.at(0)

    const o2Saturation = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_O2_SATURATION
    )?.at(0)

    const bloodPressure = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_BLOOD_PRESSURE
    )?.at(0)

    const height = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_HEIGHT
    )?.at(0)

    const bloodSugar = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_BLOOD_SUGAR
    )?.at(0)

    const weight = getAnswerValuesFromItems(
      flatAnswersArray,
      RocAssessmentQuestionnaireItem.VITALS_WEIGHT
    )?.at(0)

    return {
      [VitalsFormField.TEMPERATURE]: temperature,
      [VitalsFormField.PULSE]: pulse,
      [VitalsFormField.RESPIRATIONS]: respirations,
      [VitalsFormField.O2_SATURATION]: o2Saturation,
      [VitalsFormField.BLOOD_PRESSURE]: bloodPressure,
      [VitalsFormField.HEIGHT]: height,
      [VitalsFormField.BLOOD_SUGAR]: bloodSugar,
      [VitalsFormField.WEIGHT]: weight
    }
  }

  buildFlatAnswers(formData: RocFormData): FlatAnswerMutation[] {
    return [
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_TEMPERATURE,
        value: formData[VitalsFormField.TEMPERATURE]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_PULSE,
        value: formData[VitalsFormField.PULSE]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_RESPIRATIONS,
        value: formData[VitalsFormField.RESPIRATIONS]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_O2_SATURATION,
        value: formData[VitalsFormField.O2_SATURATION]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_BLOOD_PRESSURE,
        value: formData[VitalsFormField.BLOOD_PRESSURE]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_HEIGHT,
        value: formData[VitalsFormField.HEIGHT]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_BLOOD_SUGAR,
        value: formData[VitalsFormField.BLOOD_SUGAR]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.VITALS_WEIGHT,
        value: formData[VitalsFormField.WEIGHT]
      }
    ]
  }
}
